import { render, staticRenderFns } from "./material-select.vue?vue&type=template&id=06801a46&scoped=true"
import script from "./material-select.vue?vue&type=script&lang=js"
export * from "./material-select.vue?vue&type=script&lang=js"
import style0 from "./material-select.vue?vue&type=style&index=0&id=06801a46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06801a46",
  null
  
)

export default component.exports